import identity from 'transmute/identity';
import { fetchLeadPipelineSettings } from '../../input/leads/leadPipelineSettingsApi';
import { InMemoryCache } from '../InMemoryCache';
export const makeLeadPipelineSettingsCache = () => new InMemoryCache('LeadPipelineSettingsCache', identity, ({
  httpClient
}) => key => fetchLeadPipelineSettings(key, httpClient));